import React, { useEffect, useState } from "react";
import Instance from "../Services/Instance";
import config from "../Services/config.js";
import SideBar from "../Layouts/SideBar";
import "../Assets/Styles/DesactivationSettings.css";

function DesactivationSettings() {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [desactivation, setDesactivation] = useState(null);
    const [desactivationId, setDesactivationId] = useState(null);

    // États pour les valeurs actuelles
    const [desactivationLivraison, setDesactivationLivraison] = useState("dakoyLivrer");
    const [desactivationPayment, setDesactivationPayment] = useState("dakoyFaye");

    useEffect(() => {
        fetchDesactivationSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchDesactivationSettings = async () => {
        try {
            setLoading(true);
            const result = await Instance.get(`${config.api_url}/getDesactivation`);
            
            if (result.data && result.data.length > 0) {
                const settings = result.data[0];
                setDesactivation(settings);
                setDesactivationId(settings._id);
                setDesactivationLivraison(settings.desactivationLivraison || "dakoyLivrer");
                setDesactivationPayment(settings.desactivationPayment || "dakoyFaye");
            }
            setLoading(false);
        } catch (error) {
            setError(error.response?.data?.message || "Erreur lors du chargement des paramètres");
            setLoading(false);
        }
    };

    const handleUpdateSettings = async () => {
        try {
            setLoading(true);
            setError("");
            setSuccess("");

            const data = {
                desactivationLivraison,
                desactivationPayment
            };

            if (desactivationId) {
                // Mise à jour si l'ID existe
                await Instance.put(`${config.api_url}/updateDesactivation/${desactivationId}`, data);
                setSuccess("Paramètres mis à jour avec succès !");
            } else {
                // Création si pas d'ID
                const result = await Instance.post(`${config.api_url}/createDesactivation`, data);
                setDesactivationId(result.data._id);
                setSuccess("Paramètres créés avec succès !");
            }

            setLoading(false);
            
            // Rafraîchir les données après 2 secondes
            setTimeout(() => {
                fetchDesactivationSettings();
                setSuccess("");
            }, 2000);

        } catch (error) {
            setError(error.response?.data?.message || "Erreur lors de la mise à jour");
            setLoading(false);
        }
    };

    const getStatusBadge = (status, type) => {
        if (type === "livraison") {
            return status === "dakoyLivrer" 
                ? <span className="status-badge active">✅ Livraison Activée</span>
                : <span className="status-badge inactive">⛔ Livraison Désactivée</span>;
        } else {
            return status === "dakoyFaye" 
                ? <span className="status-badge active">✅ Paiement Activé</span>
                : <span className="status-badge inactive">⛔ Paiement Désactivé</span>;
        }
    };

    return (
        <div className="a-new-product">
            <SideBar />
            <div className='show-elements-details desactivation-settings-container'>
                <h2 className="desactivation-settings-title">
                    ⚙️ Paramètres de Désactivation
                </h2>

                {loading && <p className="loading-text loading-pulse">Chargement...</p>}

                {/* Section Livraison */}
                <div className="settings-section">
                    <h3 className="settings-section-title">
                        📦 Gestion de la Livraison
                    </h3>
                    
                    <div className="mb-15">
                        <p className="mb-10">
                            <strong>Statut actuel :</strong> {getStatusBadge(desactivationLivraison, "livraison")}
                        </p>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Modifier le statut de livraison :
                        </label>
                        <select 
                            value={desactivationLivraison}
                            onChange={(e) => setDesactivationLivraison(e.target.value)}
                            className="form-select"
                        >
                            <option value="dakoyLivrer">✅ Activer la livraison</option>
                            <option value="livrerWoumako">⛔ Désactiver la livraison</option>
                        </select>
                    </div>

                    
                </div>

                {/* Section Paiement */}
                <div className="settings-section">
                    <h3 className="settings-section-title">
                        💳 Gestion du Paiement
                    </h3>
                    
                    <div className="mb-15">
                        <p className="mb-10">
                            <strong>Statut actuel :</strong> {getStatusBadge(desactivationPayment, "paiement")}
                        </p>
                    </div>

                    <div className="form-group">
                        <label className="form-label">
                            Modifier le statut de paiement :
                        </label>
                        <select 
                            value={desactivationPayment}
                            onChange={(e) => setDesactivationPayment(e.target.value)}
                            className="form-select"
                        >
                            <option value="dakoyFaye">✅ Activer le paiement</option>
                            <option value="Fayouko">⛔ Désactiver le paiement</option>
                        </select>
                    </div>

                    
                </div>

                {/* Bouton de sauvegarde */}
                <div className="save-button-container">
                    <button 
                        onClick={handleUpdateSettings}
                        disabled={loading}
                        className="save-button"
                    >
                        {loading ? '⏳ Enregistrement...' : '💾 Enregistrer les modifications'}
                    </button>
                </div>

                {/* Messages de succès et erreur */}
                {success && (
                    <div className="message-box message-success">
                        ✅ {success}
                    </div>
                )}

                {error && (
                    <div className="message-box message-error">
                        ❌ {error}
                    </div>
                )}

                {/* Récapitulatif */}
                {desactivation && (
                    <div className="recap-section">
                        <h4 className="recap-title">📊 Récapitulatif des paramètres</h4>
                    
                        <p><strong>Livraison :</strong> {desactivationLivraison === "dakoyLivrer" ? "✅ Activée" : "⛔ Désactivée"}</p>
                        <p><strong>Paiement :</strong> {desactivationPayment === "dakoyFaye" ? "✅ Activé" : "⛔ Désactivé"}</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DesactivationSettings;